import React, { useContext, useState } from "react";
import { useQuery } from "react-query";
import { QK } from "../../../base/qk";
import { getHandovers } from "../../../api/services/notification";
import {
  Card,
  CardContent,
  Typography,
  Pagination,
  CircularProgress,
  Box,
} from "@mui/material";
import MyContext from "../../../context/MyContext";

const HandoverContent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { locationID } = useContext(MyContext);
  const alertsPerPage = 10;

  const { data: handovers, isLoading } = useQuery(
    [QK.handovers, currentPage, locationID],
    () => getHandovers(currentPage, locationID),
    { keepPreviousData: true, enabled: !!currentPage || !!locationID }
  );

  const totalRecords = handovers?.count || 0;
  const totalPages = Math.ceil(totalRecords / alertsPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  if (isLoading)
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );

  return (
    <Box sx={{ width: "90%", mx: "auto", mt: 4, px: 2 }}>
      {handovers?.results?.map((alert) => (
        <Card
          key={alert.id}
          variant="outlined"
          sx={{
            mb: 1,
            p: 1,
            boxShadow: 3,
            borderRadius: 2,
            borderLeft: "2px solid #1976d2",
          }}
        >
          <CardContent>
            {/* Top Row (Date & Time) */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1}
            >
              <Typography variant="subtitle2" color="textSecondary">
                {alert.created_at.split("T")[0]} |{" "}
                {alert.created_at.split("T")[1]}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  background: "lightgray",
                  color: "#000",
                  px: 2,
                  py: 0.5,
                  borderRadius: 1,
                  fontSize: "0.8rem",
                }}
              >
                {alert.visit_name}
              </Typography>
            </Box>

            {/* Main Content */}
            <Typography
              variant="h6"
              sx={{ mt: 1, fontWeight: "bold", color: "#333" }}
            >
              {alert.client_name}
            </Typography>

            <Typography
              variant="body2"
              sx={{ mt: 1, color: "#555", fontWeight: "500" }}
            >
              <strong>Employee:</strong> {alert.candidate_name}
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mt: 2,
                color: "#666",
                background: "#f5f5f5",
                p: 1.5,
                borderRadius: 1,
                fontSize: "0.9rem",
              }}
            >
              <strong>Notes:</strong> {alert.notes || "N/A"}
            </Typography>
          </CardContent>
        </Card>
      ))}

      {/* Pagination */}
      <Box display="flex" justifyContent="center" mt={3} mb={5}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          shape="rounded"
        />
      </Box>
    </Box>
  );
};

export default HandoverContent;
